module.exports = __webpack_public_path__ + "img/CapTechScoutHP.2e206c63.webp";